import { BehaviorSubject } from 'rxjs'

import config from './config'
import { handleResponse } from './handle-response'

//API
import { userService } from './user.service'

//JWT
import { jwtDecode } from 'jwt-decode'

const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')))

export const authenticationService = {
    login,
    signup,
    logout,
    refreshToken,
	updateUserDetails,
    establishSession,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue () { return currentUserSubject.value },
    forgotPassword,
    changePassword,
    // loginFacebook,
    loginGoogle
}

function login(body) {
    const requestOptions = { method: 'POST', body }

    return fetch(`${config.apiUrl}/auth/token/`, requestOptions)
        .then(handleResponse)
        .then(createAuthenticatedSession)

}

function signup(body) {
    return userService.signup(body)
        .then(createAuthenticatedSession)
}

// function loginFacebook(body) {
//     const requestOptions = { method: 'POST', headers: { "Content-Type": "application/json"}, body: JSON.stringify(body)  }

//     return fetch(`${config.apiUrl}/oauth/facebook/`, requestOptions)
//         .then(handleResponse)
//         .then(async response => {
//             // store user details and jwt token in local storage to keep user logged in between page refreshes
//             const token = jwtDecode(response['access_token'])
//             console.log("token fb", token)
//             response = {
//                 ...response,
//                 expiry: token['exp'],
//             }
//             localStorage.setItem('currentUser', JSON.stringify(response))
//             currentUserSubject.next(response)

//             await userService.details()
//             .then(user => {
//                 response = {...response, user}
//                 localStorage.setItem('currentUser', JSON.stringify(response))
//                 currentUserSubject.next(response)
//             })
            

//             return response
//         })
        
// }

function loginGoogle(body) {
    const requestOptions = { method: 'POST', headers: { "Content-Type": "application/json"}, body: JSON.stringify(body)  }

    return fetch(`${config.apiUrl}/oauth/google/`, requestOptions)
        .then(handleResponse)
        .then(createAuthenticatedSession)

}

function establishSession(response) {
    return createAuthenticatedSession(response)
}

async function createAuthenticatedSession(response) {
    const accessToken = response['access'] || response['access_token'];
    const refreshToken = response['refresh'] || response['refresh_token'];

    if (!accessToken || !refreshToken) {
        throw new Error('Signup/login response did not include authentication tokens.')
    }

    const token = jwtDecode(accessToken)
    window._accessToken = accessToken;

    let baseData = {
        refresh_token: refreshToken,
        expiry: token.exp
    };

    localStorage.setItem('currentUser', JSON.stringify(baseData))
    currentUserSubject.next(baseData)

    const user = await userService.details();

    baseData = { ...baseData, user };
    localStorage.setItem('currentUser', JSON.stringify(baseData));
    currentUserSubject.next(baseData);

    return baseData
}

async function refreshToken() {
    const tokens = authenticationService.currentUserValue
    const refresh = tokens['refresh'] || tokens['refresh_token'];
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refresh })
    }

    await fetch(`${config.apiUrl}/auth/token/refresh/`, requestOptions)
        .then((response) => {
            return handleResponse(response)
        })
        .then(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            const token = jwtDecode(user['access'])
			window._accessToken = user['access'];
			let updated = { ...tokens, expiry: token.exp };
			updated.refresh_token = user['refresh_token'] || user['refresh'] || refresh;

            localStorage.setItem('currentUser', JSON.stringify(updated))
            currentUserSubject.next(updated)

            return updated
        })
        .catch(error => {
            console.log("failing refreshing token", error)
        })
}

function updateUserDetails(newUserData) {
    const currentData = currentUserSubject.value || {};
    const updated = { ...currentData, user: newUserData };
    localStorage.setItem('currentUser', JSON.stringify(updated));
    currentUserSubject.next(updated);
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    currentUserSubject.next(null);
	return Promise.resolve().then(() => {
		window.location.reload();
	  });
}

function forgotPassword(body){
    const requestOptions = { method: 'POST', body }

    return fetch(`${config.apiUrl}/auth/forgot_password/`, requestOptions)
        .then(handleResponse)
        .then(async response => {
            return response
        })
}

function changePassword(body){
    const requestOptions = { method: 'POST', body }

    return fetch(`${config.apiUrl}/auth/change_password/`, requestOptions)
        .then(handleResponse)
        .then(async response => {
            return response
        })
}
